import React from 'react';
import { Route, IndexRedirect } from 'react-router';

import CoreLayout from 'messaging/layouts/CoreLayout';
import MailboxLayout from 'messaging/layouts/MailboxLayout';

import MessagesPage from 'messaging/pages/MessagesPage';
import RecipientsPage from 'messaging/pages/RecipientsPage';
import DiffusionPage from 'messaging/pages/DiffusionPage';

export default store => (
  <Route path="/" component={CoreLayout}>
    <IndexRedirect to="/mailbox" />
    <Route component={MailboxLayout}>
      <Route path="mailbox" component={MessagesPage} />
    </Route>
    <Route path="recipients" component={RecipientsPage} />
    <Route path="diffusion" component={DiffusionPage} />
  </Route>
);



// WEBPACK FOOTER //
// ./src/modules/messaging/routes/index.js